export const REVIEW_FEATURE_TEXT: Record<string, string> = {
  compress_pdf: 'compressing your PDF',
  pdf_converter: 'converting your file',
  rotate_pdf: 'rotating your PDF',
  split_pdf: 'splitting your PDF',
  merge_pdf: 'merging PDFs',
  delete_pdf_pages: 'deleting PDF pages',
  extract_pdf_pages: 'extracting PDF pages',
  edit_pdf: 'editing your PDF',
  pdf_annotator: 'annotating your PDF',
  word_to_pdf: 'converting Word to PDF',
  excel_to_pdf: 'converting Excel to PDF',
  powerpoint_to_pdf: 'converting PowerPoint to PDF',
  image_to_pdf: 'converting images to PDF',
  pdf_to_word: 'converting PDF to Word',
  pdf_to_excel: 'converting PDF to Excel',
  pdf_to_powerpoint: 'converting PDF to PowerPoint',
  pdf_to_image: 'converting PDF to images',
  esign_pdf: 'signing your PDF',
};

export const REVIEW_FEATURE_TEXT_FALLBACK = 'working on your PDF';

export const getFeatureText = (featureName?: string | null): string =>
  (featureName && REVIEW_FEATURE_TEXT[featureName]) ||
  REVIEW_FEATURE_TEXT_FALLBACK;
